import * as sonbpIfconst from "../sonbpIf/base/constants";


//------------------------------------------------------------------------------
// 定数
//------------------------------------------------------------------------------

/**
 * 編集モードの種別
 * */
export const EDIT_MODE_KIND = {
    SET_PHOTO: sonbpIfconst.MODE_PHOTO_REGIST,      // 画像読込・配置
    CHANGE_PHOTO: sonbpIfconst.MODE_PHOTO_REPLACE,  // 画像入替(スマホ専用)
    MANI_PHOTO: sonbpIfconst.MODE_PHOTO_MANI,       // 画像操作
    GREETING: sonbpIfconst.MODE_GREETING_MANI,      // あいさつ文操作モード
    SENDER: sonbpIfconst.MODE_SENDER_MANI,          // 差出人操作モード
    STAMP: sonbpIfconst.MODE_STAMP_MANI,            // スタンプ操作モード
    MYSTAMP: sonbpIfconst.MODE_MYSTAMP_MANI,        // Myステッカー操作モード
    FONTGENIC: sonbpIfconst.MODE_FONTGENIC_MANI,    // 手書きスタンプ操作モード
    CHANGE_BRIGHT: sonbpIfconst.CHANGE_BRIGHT       // 明るさ調整モード
} as const;
export type editModeKind = typeof EDIT_MODE_KIND[keyof typeof EDIT_MODE_KIND];

/**
 * 組方向
 */
export const KUMIHAN_HV = {
    VERTICAL: "1",      // 縦書き
    HORIZONTAL: "2",    // 横書き
} as const;
export type kumihanHv = typeof KUMIHAN_HV[keyof typeof KUMIHAN_HV];

/**
 * 編集画面 固有の定数
 */
export module EditConst {

    /**
     * 文字レイアウトコンボ 表示名(横)
     */
    export const CHAR_LAYOUT_Y: string = "横書き";
    /**
     * 文字レイアウトコンボ 表示名(縦)
     */
    export const CHAR_LAYOUT_T: string = "縦書き";
    /**
     * 文字レイアウトコンボ 表示名(センター横)
     */
    export const CHAR_LAYOUT_CY: string = "横書き（中央揃え）";

    /**
     * 行揃えコンボ 表示名(横書き用)
     */
    export const ALIGN_Y_LEFT: string = "左揃え";
    export const ALIGN_Y_CENTER: string = "中央揃え";
    export const ALIGN_Y_RIGHT: string = "右揃え";
    /**
     * 行揃えコンボ 表示名(縦書き用)
     */
    export const ALIGN_T_TOP: string = "上揃え";
    export const ALIGN_T_MIDDLE: string = "中揃え";
    export const ALIGN_T_BOTTOM: string = "下揃え";

    /**
     * 電話番号コンボ 表示名
     */
    export const CONTACT_TEL_DISP: string = "TEL";
    export const CONTACT_CELLULAR_DISP: string = "携帯";
    export const CONTACT_FAX_DISP: string = "FAX";
    export const CONTACT_TEL_FAX_DISP: string = "TEL&FAX";
    /**
     * 電話番号コンボ DB値
     */
    export const CONTACT_TEL_VAL: number = 0;
    export const CONTACT_CELLULAR_VAL: number = 1;
    export const CONTACT_FAX_VAL: number = 2;
    export const CONTACT_TEL_FAX_VAL: number = 3;
    /**
     * デザインマスタ 機能制限フラグ DB値
     */
    export const DSN_MST_EDIT_MODE_OFF: string = "0";
    export const DSN_MST_EDIT_MODE_LIMIT: string = "1";

    /**
     * 画像補正ボタンのキャプション(PC用)
     */
    export const PHOTO_CORRECT_CAPTION_PC_OFF: string = "画像補正しない";
    export const PHOTO_CORRECT_CAPTION_PC_ON: string = "画像補正する";
    /**
     * 画像補正ボタンのキャプション(SP用)
     */
    export const PHOTO_CORRECT_CAPTION_SP_OFF: string = "画像補正あり";
    export const PHOTO_CORRECT_CAPTION_SP_ON: string = "画像補正なし";

    /**
     * 差出人 入力タイプ 個人
     */
    export const SENDER_TYPE_PORSONAL: string = "0";
    export const SENDER_TYPE_PORSONAL_STR: string = "個人用";
    /**
     * 差出人 入力タイプ 法人
     */
    export const SENDER_TYPE_CORP = "1";
    export const SENDER_TYPE_CORP_STR: string = "法人用";
    /**
     * 差出人 入力タイプ 自由入力
     */
    export const SENDER_TYPE_FREE: string = "2";
    export const SENDER_TYPE_FREE_STR: string = "自由入力";

    /**
     * あいさつ文・差出人 文字サイズ(デフォルト) 縦書き用
     */
    export const FONT_SIZE_DEFAULT_T: number = 10;
    /**
     * あいさつ文・差出人 文字サイズ(デフォルト) 横書き用
     */
    export const FONT_SIZE_DEFAULT_Y: number = 10;
    /**
     * あいさつ文・差出人 文字サイズ(最小)
     */
    export const FONT_SIZE_MIN: number = 8;
    /**
     * あいさつ文・差出人 文字サイズ(最大)
     */
    export const FONT_SIZE_MAX: number = 24;
    /**
     * あいさつ文・差出人 文字サイズ(ステップ数)
     */
    export const FONT_SIZE_STEP: number = 0.5;

    /**
     * 印刷タイプ(1:印刷, 2: 銀塩, 0:印刷・銀塩 両方)
     */
    export const PRINT_TYPE_PRINT: string = "1";
    export const PRINT_TYPE_GINEN: string = "2";
    export const PRINT_TYPE_BOTH: string = "0";

    /**
     * 組方向 DB値 縦
     */
    export const DIRECTION_T: string = "0";
    /**
     * 組方向 DB値 横
     */
    export const DIRECTION_Y: string = "1";
    /**
     * 組方向 DB値 横(センター)
     */
    export const DIRECTION_CY: string = "2";

    /**
     * 行揃え DB値
     */
    export const ALIGN_9: string = "9";
    export const ALIGN_8: string = "8";
    export const ALIGN_7: string = "7";
    export const ALIGN_6: string = "6";
    export const ALIGN_3: string = "3";

    /**
     * デザイン区分 DB値
     * */
    export const NENGA: string = "0";
    export const MOCYU: string = "1";
    export const KANCYU: string = "2";
    export const TSUNEN: string = "3";

    /*
     * あいさつ文デフォルトサイズ(縦組の場合の)幅 (mm)
     */
    export const GREETING_DEFAULT_WIDTH = 30;

    /*
     * あいさつ文デフォルトサイズ(縦組の場合の)高さ (mm)
     */
    export const GREETING_DEFAULT_HEIGHT = 80;

    /**
     * レイアウトコード 法人・縦用
     * */
    export const LAYOUTCD_HOJIN_T: string = "T14A";
    /**
     * レイアウトコード 法人・横用
     * */
    export const LAYOUTCD_HOJIN_Y: string = "Y14A";
    /**
     * レイアウトコード 法人・センター横用
     * */
    export const LAYOUTCD_HOJIN_CY: string = "C14A";
    /**
     * レイアウトコード 個人・縦用
     * */
    export const LAYOUTCD_PERSONAL_T: string = "T04A";
    /**
     * レイアウトコード 個人・横用
     * */
    export const LAYOUTCD_PERSONAL_Y: string = "Y04A";
    /**
     * レイアウトコード 個人・センター横用
     * */
    export const LAYOUTCD_PERSONAL_CY: string = "C04A";

    /**
     * 次へボタン押下時の確認メッセージのYESボタンキャプション
     */
    export const NEXTPAGE_CONFIRM_YES: string = "このまま進む";
    /**
     * 次へボタン押下時の確認メッセージのNOボタンキャプション
     */
    export const NEXTPAGE_CONFIRM_NO: string = "戻って入力する";

    /**
     * あいさつ文文例集のワイルドカード
     */
    export const GREETING_SAMPLE_WILDCARD: string = "●";

    /**
     * あいさつ文文例集のワイルドカード2
     */
    export const GREETING_SAMPLE_WILDCARD2: string = "■";

    /**
     * 次ページ名
     */
    export const NEXTPAGE_NAME: string = "Preview";

    /**
     * 画像一覧の選択状態判別値(選択)
     */
    export const IMG_SELECTED: string = "yes";
    /**
     * 画像一覧の選択状態判別値(未選択)
     */
    export const IMG_NOSELECT: string = "no";


    /**
     * ヘッダータイトル(SP用)：メイン
     */
    export const TITLE_MAIN: string = "はがきの編集";
    /**
     * ヘッダータイトル(SP用)：画像一覧
     */
    export const TITLE_IMAGELIST: string = "画像を読み込む";
    /**
     * ヘッダータイトル(SP用)：画像操作
     */
    export const TITLE_MANIPHOTO: string = "画像調整";
    /**
     * ヘッダータイトル(SP用)：画像入替
     */
    export const TITLE_SWAPPHOTO: string = "画像入替";
    /**
     * ヘッダータイトル(SP用)：あいさつ文のメイン
     */
    export const TITLE_GREETING: string = "あいさつ文位置調整";
    /**
     * ヘッダータイトル(SP用)：あいさつ文の編集
     */
    export const TITLE_GREETING_EDIT: string = "あいさつ文編集";
    /**
     * ヘッダータイトル(SP用)：差出人のメイン
     */
    export const TITLE_SENDER: string = "差出人情報位置調整";
    /**
     * ヘッダータイトル(SP用)：差出人の編集
     */
    export const TITLE_SENDER_EDIT: string = "差出人情報編集";
    /**
     * ヘッダータイトル(SP用)：スタンプのメイン
     */
    export const TITLE_STAMP: string = "スタンプ位置調整";
    /**
     * ヘッダータイトル(SP用)：スタンプの追加
     */
    export const TITLE_STAMP_EDIT: string = "スタンプ編集";
    /**
     * ヘッダータイトル(SP用)：Myステッカーのメイン
     */
    export const TITLE_MYSTAMP: string = "写真スタンプ位置調整";
    /**
     * ヘッダータイトル(SP用)：Myステッカーの追加
     */
    export const TITLE_MYSTAMP_EDIT: string = "写真スタンプ編集";
    /**
     * ヘッダータイトル(SP用)：手書きスタンプのメイン
     */
    export const TITLE_TEGAKISTAMP: string = "手書き位置調整";
    /**
     * ヘッダータイトル(SP用)：手書きスタンプの追加
     */
    export const TITLE_TEGAKISTAMP_EDIT: string = "手書き編集";
    /**
     * ヘッダータイトル(SP用)：手書きスタンプの色変更
     */
    export const TITLE_TEGAKISTAMP_COLOR: string = "スタンプ色変更";
    /**
     * ヘッダータイトル(SP用)：明るさ調整
     */
    export const TITLE_CHANGE_BRIGHT: string = "明るさ変更";

    /**
     * 差出人の編集適用ボタンのキャプション(SP用)
     */
    export const SENDER_APPLY_BTN_ADD: string = "追加";
    /**
     * 差出人の編集適用ボタンのキャプション(SP用)
     */
    export const SENDER_APPLY_BTN_UPD: string = "更新";

    /**
     * 入力欄を隠す/表示するキャプション
     */
    export const HIDE_AREA_FADE_IN: string = "入力欄を表示する　↓　↓　↓　入力欄を表示する";
    export const HIDE_AREA_FADE_OUT: string = "入力欄を隠す　↑　↑　↑　入力欄を隠す";

    /**
     * ガイダンスの表示タイムアウト値(ms)
     * */
    export const GUIDANCE_SHOW_TIMEOUT: number = 30000;

    /**
     * sessionStorage格納用キー：F5リロード判定用
     */
    export const SESSION_STORAGE_KEY_RELOADED: string = "EDIT_RELOADED";

    /*
     * セッションストレージ用 戻る判定
     */
    export const SESSION_STORAGE_FROM_PREV: string = "POSCA_FROM_PREV";


    /**
     * エラーメッセージ表示用の項目タイトル
     */
    export const SENDER_ITEM_NAME_ZIP: string = "郵便番号";
    export const SENDER_ITEM_NAME_ZIP1: string = "郵便番号１";
    export const SENDER_ITEM_NAME_ZIP2: string = "郵便番号２";
    export const SENDER_ITEM_CAPTION_ADDRESS1: string = "住所１";
    export const SENDER_ITEM_CAPTION_ADDRESS2: string = "住所２";
    export const SENDER_ITEM_CAPTION_ADDRESS3: string = "住所３";
    export const SENDER_ITEM_CAPTION_NAME: string = "お名前";
    export const SENDER_ITEM_CAPTION_LNAME: string = "姓";
    export const SENDER_ITEM_CAPTION_FNAME: string = "名";
    export const SENDER_ITEM_CAPTION_LRUBI: string = "姓ルビ";
    export const SENDER_ITEM_CAPTION_FRUBI: string = "名ルビ";
    export const SENDER_ITEM_CAPTION_PS: string = "添書";
    export const SENDER_ITEM_CAPTION_TITLE: string = "肩書き";
    export const SENDER_ITEM_CAPTION_TEL1: string = "お電話番号１";
    export const SENDER_ITEM_CAPTION_TEL2: string = "お電話番号２";
    export const SENDER_ITEM_CAPTION_TEL1_1: string = "電話番号１－１";
    export const SENDER_ITEM_CAPTION_TEL1_2: string = "電話番号１－２";
    export const SENDER_ITEM_CAPTION_TEL1_3: string = "電話番号１－３";
    export const SENDER_ITEM_CAPTION_TEL2_1: string = "電話番号２－１";
    export const SENDER_ITEM_CAPTION_TEL2_2: string = "電話番号２－２";
    export const SENDER_ITEM_CAPTION_TEL2_3: string = "電話番号２－３";
    export const SENDER_ITEM_CAPTION_EMAIL1: string = "Ｅメール１";
    export const SENDER_ITEM_CAPTION_EMAIL2: string = "Ｅメール２";
    export const SENDER_ITEM_CAPTION_COMPANY: string = "会社名";
    export const SENDER_ITEM_CAPTION_DEPARTMENT: string = "部署名";

    /**
     * 差出人：最大行数(差出人 自由入力)
     */
    /*export const SENDER_MAXROW_FREE: number = 10;*/
    /**
     * 差出人：最大文字数(差出人 自由入力) 最大文字数(全角400文字、半角800文字)
     */
    export const SENDER_MAXLEN_FREE: number = 800;
    /**
     * 差出人：最大文字数(住所1～3)
     */
    export const SENDER_MAXLEN_JUSHO: number = 80;
    /**
     * 差出人：最大文字数(姓)
     */
    export const SENDER_MAXLEN_LASTNAME: number = 26;
    /**
     * 差出人：最大文字数(名)
     */
    export const SENDER_MAXLEN_FIRSTNAME: number = 26;
    /**
     * 差出人：最大文字数(かな)
     */
    export const SENDER_MAXLEN_RUBI: number = 40;
    /**
     * 差出人：最大文字数(添え書き)
     */
    export const SENDER_MAXLEN_PS: number = 40;
    /**
     * 差出人：最大文字数(会社名)
     */
    export const SENDER_MAXLEN_COMPANY: number = 64;
    /**
     * 差出人：最大文字数(部署)
     */
    export const SENDER_MAXLEN_DEPARTMENT: number = 64;
    /**
     * 差出人：最大文字数(肩書)
     */
    export const SENDER_MAXLEN_TITLE: number = 64;
    /**
     * 差出人：最大文字数(郵便番号(前))
     */
    export const SENDER_MAXLEN_ZIP1: number = 3;
    /**
     * 差出人：最大文字数(郵便番号(後))
     */
    export const SENDER_MAXLEN_ZIP2: number = 4;
    /**
     * 差出人：最大文字数(電話番号(1))
     */
    export const SENDER_MAXLEN_TEL1: number = 6;
    /**
     * 差出人：最大文字数(電話番号(2))
     */
    export const SENDER_MAXLEN_TEL2: number = 4;
    /**
     * 差出人：最大文字数(電話番号(3))
     */
    export const SENDER_MAXLEN_TEL3: number = 4;
    /**
     * 差出人：最大文字数(E-mail etc...)
     */
    export const SENDER_MAXLEN_EMAIL: number = 128;


    /**
     * あいさつ文：最大行数
     */
    /*export const GREETING_MAXROW: number = 10;*/
    /**
     * あいさつ文：最大文字数(全角400文字、半角800文字)
     */
    export const GREETING_MAXLEN: number = 800;

    /**
     * あいさつ文縦書きの単位変換する
     */
    export const GREETING_VERT_CONV: number = 1;

    /**
     * あいさつ文縦書きの単位変換しない
     */
    export const GREETING_VERT_NO_CONV: number = 2;

    /**
     * キタムラリテーラID
     */
    export const KITAMURA: string = "1";

    /**
     * 仕上がり別メッセージ
     */
    //export const IMAGE_GUIDANCE_MESSAGE_GINEN_: string = "周囲の赤枠部分は有効保証エリア外となり、\n製造上の裁断誤差により絵柄が一部カットされる場合があります。\n赤枠の内側に画像やスタンプ・文字を配置してください。\nこのメッセージはクリックすると非表示になります。";
    export const IMAGE_GUIDANCE_MESSAGE_GINEN: string = "周囲の赤枠部分は製造上カットされます。\n但し、白フチが出ないようにするために、\n赤枠外周部分まで画像を配置してください。\nこのメッセージはクリックすると非表示になります。";
    export const IMAGE_GUIDANCE_MESSAGE_INSATSU: string = "印刷仕上げは周囲に白フチがつきます。\nこのメッセージはクリックすると非表示になります。\n ";
}

